import { styled } from "@linaria/react";
import { isMobile, isTablet } from "../../../@css-style";
import { CSSProperties } from "react";

export const ElValue = styled.h3`
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--theme-main-flat-color);
  transition: all 0.4s ease;
  text-transform: none;
  letter-spacing: normal;
  font-size: 36px;
  font-weight: 700;
  ${String(isTablet)} {
    font-size: 25px;
  }
`;

interface TableCellCSSProps extends CSSProperties {
  // NOTE: These are public CSS variables that we use to allow CSS-only consumers
  // We do this ourselves instead of leveraging Linaria's dynamic styles because
  // that approach results in randomly-named CSS variables, which would not provide
  // a friendly interface for CSS-only consumers.
  "--hashTag"?: string;
}

interface ElHeadLineProps {
  style?: TableCellCSSProps;
}
export const ElHeadLine = styled.h1<ElHeadLineProps>`
  --hashTag: none;

  display: flex;
  text-align: left;
  flex-direction: column;
  font-size: 40px;
  width: 100%;
  font-weight: 700;
  color: var(--theme-main-flat-dark-color);
  transition: all 0.4s ease;
  text-transform: none;
  font-weight: 500;
  letter-spacing: normal;
  background-color: transparent;
  &::before {
    content: var(--hashTag);
    color: #7fb4de;
    font-family: Poppins;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
    margin-bottom: 5px;
  }
  ${String(isMobile)} {
    font-size: 32px;
  }
  /* background-image: linear-gradient(45deg, #10575c 0%, #297b10 100%); */
`;

export const ElHeadLineBig = styled.h1`
  display: flex;
  flex-direction: column;
  font-size: 46px;
  width: 100%;
  font-weight: 600;
  color: var(--theme-main-flat-dark-color);
  transition: all 0.4s ease;
  text-transform: none;
  font-weight: 500;
  letter-spacing: normal;
  background-color: transparent;
  text-align: center;
  ${String(isMobile)} {
    font-size: 32px;
  }
  /* background-image: linear-gradient(45deg, #10575c 0%, #297b10 100%); */
`;

export const ElDetails = styled.p`
  color: #3d3d3d;
  font-family: Manrope;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 30px; /* 187.5% */
`;

export const ElSubTitle = styled.h4`
  width: 100%;
  text-align: left;
  font-size: 17px;
  font-weight: 400;
  color: var(--theme-main-flat-dark-color);
`;

export const ElAnchorButton = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--theme-main-flat-color);
  border: 1px solid var(--theme-main-green-color);
  background-color: var(--theme-main-green-color);
  transition: all 0.4s ease;
  text-transform: none;
  font-weight: 500;
  letter-spacing: normal;
  padding: 12px 24px;
  border-radius: 3px;
  &:hover {
    color: var(--theme-main-green-color);
    background-color: var(--theme-main-flat-color);
  }
`;
